import { SkillType } from '@types';
import { useFormContext } from 'react-hook-form';
import { LwFormMultiSelect } from 'redesign';
import { Section } from 'shared/components/common/form-section';
import {
  Props,
  WorkTemplateRequirementFormName,
  WorkTemplateRequirementsFormContext,
} from './work-template-requirements.types';

export const WorkTemplateRequirementsSelect = (props: Props) => {
  const { control } = useFormContext<WorkTemplateRequirementsFormContext>();

  const renderWorkTemplateRequirementSelect = (
    name: WorkTemplateRequirementFormName,
    label: string,
    filterType: SkillType
  ) => (
    <LwFormMultiSelect
      name={name}
      label={label}
      control={control}
      getOptionKey={(option) => option.id}
      renderOption={(props, option) => {
        return (
          <li {...props} key={option.id}>
            {option.name}
          </li>
        );
      }}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, value) => {
        return option?.id === value.id;
      }}
      options={props.options.filter((jr) => jr.type === filterType)}
      disabled={props.disabled}
    />
  );

  return (
    <Section sectionLabel="Werk vereisten">
      {renderWorkTemplateRequirementSelect(
        'jobRequirements.skills',
        'Vaardigheden',
        SkillType.SOFT_SKILL
      )}
      {renderWorkTemplateRequirementSelect(
        'jobRequirements.apparel',
        'Kledingvoorschriften',
        SkillType.APPAREL
      )}
      {renderWorkTemplateRequirementSelect(
        'jobRequirements.language',
        'Vereiste talen',
        SkillType.LANGUAGE
      )}
    </Section>
  );
};
